import { render, staticRenderFns } from "./DataLabel.vue?vue&type=template&id=7dd70f28"
import script from "./DataLabel.vue?vue&type=script&lang=js"
export * from "./DataLabel.vue?vue&type=script&lang=js"
import style0 from "./DataLabel.vue?vue&type=style&index=0&id=7dd70f28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports